export const FONCTIONNALITES = [
    {
        "id": "115d12ef-c76c-491d-9338-2fac2bc41950",
        "titre": "marketing digital",
        "img_src": "marketing_digital.png",
    },
    {
        "id": "e2e77d3a-e156-4aa9-9b18-687fb271c7a0",
        "titre": "accès à notre base de données des contacts",
        "img_src": "acces_bdd_contacts.png",
    },
/*
    {
        "id": "f711217a-2ef4-49d9-bf90-4cd3f81c1755",
        "titre": "publipostage",
        "img_src": "publipostage.png",
    },
*/
    {
        "id": "bedf7621-5a98-4b97-b407-b6fbf7c7b583",
        "titre": "gestion de vos campagnes sms",
        "img_src": "gestion_campagne_sms.png",
    },
    {
        "id": "cbc9fdd0-f468-45f2-90d9-4ea88e617eb8",
        "titre": "gestion de votre compte professionnelle",
        "img_src": "gestion_compte_professionnelle.png",
    },
    {
        "id": "4a54eefb-4ff6-434c-9c2e-693dda5f5e8f",
        "titre": "publicités",
        "img_src": "publicite.png",
    },
]



// WEBPACK FOOTER //
// ./src/data/fonctionnalites.js